import { useState } from "react";
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import MenuGroup from "aldoo-ra/MenuGroup";
import Button from "aldoo-ra/Button";

const HamburgerMenu = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isProductsMenuOpen, setProductsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const toggleProductsMenu = () => {
    setProductsMenuOpen((prevState) => !prevState);
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="relative">
      {/* Hamburger Button */}
      <button
        className="p-2 rounded-md text-text"
        onClick={toggleMenu}
        aria-label="Toggle Menu"
      >
        {isMenuOpen ? (
          <XMarkIcon className="w-6 h-6 text-text" />
        ) : (
          <Bars3Icon className="w-6 h-6 text-text" />
        )}
      </button>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="absolute top-[50px] -left-4 w-screen h-screen md:h-auto bg-navbar px-4 border-t border-bordered shadow-md z-50">
          {/* <div className="w-full border-t border-bordered" /> */}

          <div className="w-full flex flex-col items-start">
            {/* HeaderOxfordDictionary */}
            <MenuGroup
              name="HeaderOxfordDictionary"
              renderAs="hlist"
              variant="mobilingo_hlist_hamburger"
              menuItemRender={(item) => (
                <Button
                  variant="nav_menuitem"
                  onClick={handleMenuItemClick}
                >
                  {item.label}
                </Button>
              )}
            />
            <div className="w-full border-t border-bordered" />

            {/* Header Features */}
            <MenuGroup
              name="Header Features"
              renderAs="hlist"
              variant="mobilingo_hlist_hamburger"
              menuItemRender={(item) => (
                <Button
                  variant="nav_menuitem"
                  onClick={handleMenuItemClick}
                >
                  {item.label}
                </Button>
              )}
            />
            <div className="w-full border-t border-bordered" />

            {/* Header Pricing - Hidden for Phase 2 */}
            {/* <MenuGroup
              name="Header Pricing"
              renderAs="hlist"
              variant="mobilingo_hlist_hamburger"
              menuItemRender={(item) => (
                <Button
                  variant="nav_menuitem"
                  onClick={handleMenuItemClick}
                >
                  {item.label}
                </Button>
              )}
            />
            <div className="w-full border-t border-bordered" /> */}

            {/* Header Products (Collapsible Menu using vlist) */}
            <div className="w-full">
              {/* Root Item (Button to toggle submenu) */}
              <Button
                variant="nav_menuitem"
                className="h-[72px] flex items-center justify-between px-4 py-0 text-left"
                onClick={toggleProductsMenu}
                aria-expanded={isProductsMenuOpen}
              >
                <MenuGroup
                  name="Header Products"
                  renderAs="vlist"
                  styleOverrides={{
                    menu: "pl-[16px] py-0 my-[-16px]",
                    menu_column: "border-none",
                    menu_item: "hidden", // Hide items in root-level menu
                  }}
                  rootItemRender={(item) => (
                    <div className="flex justify-between gap-3 my-0 py-0">
                      {item.label}

                      <ChevronDownIcon
                        className={`w-5 h-5 ml-auto transform transition-transform ${
                          isProductsMenuOpen ? "rotate-180" : ""
                        }`}
                      />
                    </div>
                  )}
                />
              </Button>

              {/* Submenu */}
              {isProductsMenuOpen && (
                <div className="flex flex-col gap-1 pl-4">
                  <MenuGroup
                    name="Header Products"
                    renderAs="vlist"
                    styleOverrides={{
                      menu: "pl-[16px] py-0 -mt-4",
                      menu_column: "border-none",
                      menu_item: "px-0 my-4",
                    }}
                    rootItemRender={(item) => (
                      <div className="hidden">{item.label}</div>
                    )}
                    menuItemRender={(item) => (
                      <Button
                        variant="nav_menuitem"
                        className="text-left mb-0"
                        onClick={handleMenuItemClick}
                      >
                        {item.label}
                      </Button>
                    )}
                  />
                </div>
              )}
            </div>
            <div className="w-full border-t border-bordered" />

            {/* Header Partners */}
            <MenuGroup
              name="Header Partners"
              renderAs="hlist"
              variant="mobilingo_hlist_hamburger"
              menuItemRender={(item) => (
                <Button
                  variant="nav_menuitem"
                  onClick={handleMenuItemClick}
                >
                  {item.label}
                </Button>
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;